const defaultState = () => ({});

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS-PENDING": {
            return {
                ...state,
                config: null,
                loader: true
            }
        }
        case "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS-SUCCESS": {
            
            const { config, validationSucceeded, validationCompleted } = payload;

            return {
                ...state,
                config,
                loader: false,
                validationSucceeded,
                validationCompleted
            }
        }
        default: {
            return state;
        }
    }
};
